export default function animation() {
    /* const counterEl = document.querySelector(".js-percent-counter");
    let start = 50;
    let end = 90;
    let duration = 2500;

    let startTime = null;

    function animateCounter(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);

        const currentValue = Math.floor(start + (end - start) * progress);
        counterEl.textContent = currentValue + "%";

        if (progress < 1) {
            requestAnimationFrame(animateCounter);
        }
    }

    requestAnimationFrame(animateCounter); */
}
